
import { Component } from 'vue-property-decorator';
import AbpBase from '../lib/abpbase'
import Oidc from 'oidc-client'
import Util from "@/lib/util";

@Component
export default class LoginCallback extends AbpBase {
  mounted(){
    new Oidc.UserManager({response_mode: "fragment"}).signinRedirectCallback().then(() => {
      this.$store.state.app.oidcUserManager.getUser().then(user => {
          Util.abp.auth.setToken(user.access_token, new Date(new Date().getTime() + 1000 * user.expires_in))
          let returnUrl = localStorage.getItem('fdm-login-return-url')
          if(returnUrl){
            window.location.replace(returnUrl)
          }else{
            window.location.replace("/")
          }
        });
    }).catch(function(e) {
      console.error(e)
    })
  }
}
